import { apiClient } from "./axios"

export interface PagedResponse<T> {
  content: T[]
  page: {
    size: number
    number: number
    totalElements: number
    totalPages: number
  }
}

export interface PageParams {
  page?: number
  size?: number
  sort?: string
}

/**
 * Configuração de request por serviço. `baseURL` com uma origin própria
 * (ex.: "http://localhost:8084") envia a chamada direto ao serviço; `baseURL`
 * vazio ("") força caminho RELATIVO — passa pelo proxy do Vite em dev e pelo
 * proxy reverso/nginx em produção. Sem a propriedade, usa `VITE_API_URL`.
 */
export interface RequestOptions {
  baseURL?: string
  signal?: AbortSignal
}

/** Requisições GET tipadas com paginação. */
export async function getPage<T>(
  path: string,
  params?: PageParams & Record<string, unknown>,
  options?: RequestOptions,
): Promise<PagedResponse<T>> {
  const { data } = await apiClient.get<PagedResponse<T>>(path, {
    params,
    baseURL: options?.baseURL,
    signal: options?.signal,
  })
  return data
}

export async function getById<T>(path: string, id: string, options?: RequestOptions): Promise<T> {
  const { data } = await apiClient.get<T>(`${path}/${id}`, {
    baseURL: options?.baseURL,
    signal: options?.signal,
  })
  return data
}

export async function post<T>(path: string, body: unknown, options?: RequestOptions): Promise<T> {
  const { data } = await apiClient.post<T>(path, body, {
    baseURL: options?.baseURL,
    signal: options?.signal,
  })
  return data
}

export async function put<T>(
  path: string,
  id: string,
  body: unknown,
  options?: RequestOptions,
): Promise<T> {
  const { data } = await apiClient.put<T>(`${path}/${id}`, body, {
    baseURL: options?.baseURL,
    signal: options?.signal,
  })
  return data
}

export async function remove<T>(path: string, id: string, options?: RequestOptions): Promise<T> {
  const { data } = await apiClient.delete<T>(`${path}/${id}`, {
    baseURL: options?.baseURL,
    signal: options?.signal,
  })
  return data
}
